/** @jsxImportSource @emotion/react */
import React from "react";
import { TriggerConfigNode } from "../../../../usecases/HomeConfig/types";
import { KeyValueInput, KeyValuePair } from "../../../KeyValueInput";

export interface TriggerNodeEditorProps {
  node: TriggerConfigNode;
  optionGroups: Record<string, string[]>;
  onChange: (updater: (node: TriggerConfigNode) => TriggerConfigNode) => void;
}

export const TriggerNodeEditor = ({
  node,
  optionGroups,
  onChange,
}: TriggerNodeEditorProps) => {
  const pairs = Object.entries(node.options ?? {}).map(([key, value]) => {
    return { key, value };
  });

  const handleAdd = (pair: KeyValuePair) => {
    if (!pair.key) {
      return;
    }
    // NOTE: keyed by group, so re-adding a group replaces its value — the group
    // being triggered can only hold one selection anyway.
    onChange((current) => {
      return {
        ...current,
        options: { ...current.options, [pair.key]: pair.value },
      };
    });
  };

  const handleRemove = (index: number) => {
    // NOTE: copy + delete rather than Object.fromEntries — tsconfig targets es2018.
    onChange((current) => {
      const options = { ...current.options };
      delete options[Object.keys(current.options)[index]];
      return { ...current, options };
    });
  };

  return (
    <KeyValueInput
      label="Trigger Options"
      sourceKeyValues={optionGroups}
      pairs={pairs}
      hasAnyValue={false}
      onAdd={handleAdd}
      onRemove={handleRemove}
    />
  );
};
